import useSWR from 'swr';
import { newSecuredAxios } from '../../../utils/secured-axios';
import { buildApiV2Url } from 'src/utils/request-url';

type ApiResponse = {
  is_first_time_reservation: boolean;
  user_upcoming_reservation_count: number;
};

export const useReservationStats = (args: {
  merchantPublicId: string;
  email?: string;
}) => {
  const { merchantPublicId, email } = args;
  const baseUrl = new URL(buildApiV2Url(`/reservation_stats`));
  baseUrl.searchParams.append('merchant_public_id', merchantPublicId);
  if (email) {
    baseUrl.searchParams.append('email', email);
  }
  const swrKey = baseUrl.toString();
  const fetcher = async () => {
    const client = newSecuredAxios({
      merchantPublicId,
    });
    const { data } = await client.get<ApiResponse>(baseUrl.toString());

    return {
      isFirstTimeReservation: data.is_first_time_reservation,
      userUpcomingReservationCount: data.user_upcoming_reservation_count,
    };
  };

  const { data, error, isValidating } = useSWR(swrKey, fetcher);

  return { reservationStats: data, error, isLoading: isValidating };
};
